<template>
  <div class="body-index1">
    <Tab
      v-if="!isMobileFlag"
      :tablist="list"
      @change="changeTab"
      @constDetail="openConstDetailPop"
      @accountDetail="openAccountDetailPop"
      @serverDialog="openServerDialog"
      :tabCurrent="current"
    />
    <mTab
      v-else
      :tablist="list"
      @change="changeTab"
      @constDetail="openConstDetailPop"
      @accountDetail="openAccountDetailPop"
      @serverDialog="openServerDialog"
      :tabCurrent="current"
    />
    <Content
      v-for="(item, index) in list"
      v-if="index == current"
      :key="index"
      :tabContent="item"
      :isSearching="isSearching"
      @constDetail="openConstDetailPop"
      @search="searchId"
    />
    <Table
      :data="tableDatas"
      :sureflag="isSureDownload"
      :downflag="isDownloading"
      :clearflag="isClearFlag"
      :netError="isNetError"
      v-if="showTable"
      v-loading="tableLoading"
      @noBanlance="noBanlances"
      @onDownload="downloadId"
      @onSureDown="changeDown"
      @chanegV3="changeTab"
    />
    <Dialog
      :dialogVisible="dialogTableVisible"
      @closeDialog="closeConstDetailPop"
    />
    <Accountdialog
      :dialogVisible="accountDialogTableVisible"
      @closeDialog="closeAccountDetailPop"
    />
    <Serverdialog
      :dVisible="serverDialogVisible"
      @closeDialogs="closeServerDialod"
    />
    <!-- <advertCenter v-if="showPost"></advertCenter> -->
  </div>
</template>

<script>
import Tab from "./module/tab.vue";
import mTab from "./module/mtab.vue";
import Table from "./module/table.vue";
import Content from "./module/content.vue";
import Dialog from "./module/dialog.vue";
import {
  searchImage,
  getShutterStatus,
  previewImage,
} from "../../api/downLoad";
import {
  setToken,
  getTempUser,
  getToken,
  getNewUser,
  setAutoDownload,
  getAutoDownload,
  // 438/454 行调用了 setV4Status 却未引入，会抛 ReferenceError 导致渠道状态轮询中断
  setV4Status,
} from "../../utils/storage";
import { message } from "@/utils/resetMessage";
import Accountdialog from "./module/accountdialog";
import Serverdialog from "./module/serverdialog";
import advertCenter from "@/views/advert/advertCenter";
import { getSessionUser } from "@/api/auth";
import { shutterstockDisplayPrice } from "@/utils/price";

export default {
  components: {
    Accountdialog,
    Tab,
    Table,
    Content,
    Dialog,
    Serverdialog,
    mTab,
    advertCenter,
  },
  data() {
    return {
      _status: 0, //状态
      isLoggedIn: false,
      current: 0,
      webType: "shutterstock_V3",
      list: [
        {
          title: "默认",
          subTitle: "",
          titleState: "success",
          tip: '<ul><li>V3为备用渠道，成本比较高，价格比较贵，提供给急用的客户使用。</li> <li>最近因为官网问题，导致很多下载不稳定，非常抱歉，我们在努力修复这个问题。</li><li style="text-decoration: underline;">请不要使用360浏览器和迅雷下载（经常误判）否则会下载失败，推荐使用系统自带浏览器或者Chrome浏览器直接下载，如下载速度慢，可以尝试点击备用下载。</li> </ul>',
          label: null,
          isPop: false,
          webType: "shutterstock_V3",
          icon: "",
          status: true,
          //价格不再写死：登录用户显示他账号上的真实单价(老用户 1.9、2026-08-22 之后注册的新用户 1)，
          //未登录显示对外起步价 1 元。写死会出现"页面写 1 元、实际扣 1.9"这种投诉。
          price: shutterstockDisplayPrice("shutterstockPriceV3").price,
          priceIsStart: shutterstockDisplayPrice("shutterstockPriceV3").isStart,
        },
        {
          title: "默认_V4",
          subTitle: "",
          titleState: "success",
          tip: '<ul><li>所有图片下载格式是默认的，有矢量下矢量（EPS） 无矢量下最大尺寸JPG 请输入图片编号ID号</li><li>批量下载功能需设置允许网页弹窗（每个浏览器设置方法不同，请自行百度），推荐使用谷歌浏览器 <a href="https://www.google.cn/chrome/" target="_blank">点击下载</a></li><li style="text-decoration: underline;">请不要使用360浏览器和迅雷下载（经常误判）否则会下载失败，推荐使用系统自带浏览器或者Chrome浏览器直接下载，如下载速度慢，可以尝试点击备用下载。</li></ul>',
          label: null,
          isPop: false,
          webType: "shutterstock_V4",
          icon: "",
          status: true,
          price: 6.0,
        },
        {
          title: "SS视频",
          subTitle: "",
          titleState: "success",
          tip: '<ul><li>严选视频和4K的视频价格不同，亲下载前请确认好单价 </li> <li>如视频ID提示下架，请联系客服处理，H海视频均可下载 </li><li>视频仅提供6小时的存储时间，如未及时下载，将会二次扣费，如下载不动或者出现问题，请及时联系上方微信客服处理</li><li style="text-decoration: underline;">请不要使用360浏览器和迅雷下载（经常误判）否则会下载失败，推荐使用系统自带浏览器或者Chrome浏览器直接下载，如下载速度慢，可以尝试点击备用下载。</li></ul>',
          label: null,
          isPop: false,
          webType: "video",
          icon: "",
          status: true,
          price: 0,
        },
        {
          title: "AdobeStock",
          subTitle: "",
          tip: '<ul><li>Adobe部分图 LICENSE TYPE为：Enhanced无法下载，如需下载请联系客服，价格比较贵;</li><li>Adobe视频，音乐等下载请联系客服咨询具体价格。</li><li style="text-decoration: underline;">请不要使用360浏览器和迅雷下载（经常误判）否则会下载失败，推荐使用系统自带浏览器或者Chrome浏览器直接下载，如下载速度慢，可以尝试点击备用下载。</li></ul>',
          titleState: "success",
          label: null,
          isPop: false,
          webType: "adobestock",
          icon: require("@/assets/images/download/ic8_8.png"),
          status: true,
          price: 2,
        },
        {
          title: "AdobeStock视频",
          subTitle: "",
          titleState: "success",
          tip: '<ul><li>Adobe视频下载链接有效期仅1小时，请提交下载后马上下载保存好，如无法下载请联系上方客服</li><li style="text-decoration: underline;">请不要使用360浏览器和迅雷下载（经常误判）否则会下载失败，推荐使用系统自带浏览器或者Chrome浏览器直接下载，如下载速度慢，可以尝试点击备用下载。</li></ul>',
          label: null,
          isPop: false,
          webType: "vadobestock",
          icon: require("@/assets/images/download/ic8_8.png"),
          status: true,
          price: 0,
        },
        {
          title: "iStockphoto",
          subTitle: "",
          titleState: "success",
          tip: '<ul><li>istockphoto请复制图片ID编号进行下载，如复制网址系统无法识别</ul><li style="text-decoration: underline;">请不要使用360浏览器和迅雷下载（经常误判）否则会下载失败，推荐使用系统自带浏览器或者Chrome浏览器直接下载，如下载速度慢，可以尝试点击备用下载。</li></ul>',
          label: null,
          isPop: false,
          webType: "istockphoto",
          icon: require("@/assets/images/download/ic5_5.png"),
          status: true,
          price: 3,
        },
        {
          title: "iStockphoto视频",
          subTitle: "",
          titleState: "success",
          tip: '<ul><li>iStockphoto视频和4K的视频价格不同，亲下载前请确认好单价 </li> <li>如视频ID提示下架，请联系客服处理，视频均可下载 </li><li>视频仅提供12小时的存储时间，如未及时下载，将会二次扣费，如下载不动或者出现问题，请及时联系上方微信客服处理</li><li style="text-decoration: underline;">请不要使用360浏览器和迅雷下载（经常误判）否则会下载失败，推荐使用系统自带浏览器或者Chrome浏览器直接下载，如下载速度慢，可以尝试点击备用下载。</li></ul>',
          label: null,
          isPop: true,
          webType: "vistockphoto",
          icon: require("@/assets/images/download/ic5_5.png"),
          status: true,
          price: 0,
        },
        {
          title: "123rf",
          subTitle: "",
          titleState: "success",
          label: null,
          isPop: false,
          tip: '<ul><li>请复制官网的图片ID编号进行下载，复制网址可能无法识别搜索</li><li style="text-decoration: underline;">请不要使用360浏览器和迅雷下载（经常误判）否则会下载失败，推荐使用系统自带浏览器或者Chrome浏览器直接下载，如下载速度慢，可以尝试点击备用下载。</li></ul>',
          webType: "rfoto",
          icon: require("@/assets/images/download/ic3_3.png"),
          status: true,
          price: 2,
        },
        {
          title: "Veer",
          subTitle: "",
          tip: '<ul><li>Veer素材仅提供【照片】和【插画】板块的素材下载，其他素材板块暂时不支持下载，如有需要可以联系上方客服咨询</li><li>如素材提示下架，可以联系上方客服咨询</li><li style="text-decoration: underline;">请不要使用360浏览器和迅雷下载（经常误判）否则会下载失败，推荐使用系统自带浏览器或者Chrome浏览器直接下载，如下载速度慢，可以尝试点击备用下载。</li></ul>',
          titleState: "success",
          label: null,
          webType: "veer",
          isPop: false,
          icon: require("@/assets/images/download/veer.png"),
          status: true,
          price: 3,
        },
        {
          title: "Dreamstime",
          subTitle: "",
          tip: '<ul><li style="text-decoration: underline;">请不要使用360浏览器和迅雷下载（经常误判）否则会下载失败，推荐使用系统自带浏览器或者Chrome浏览器直接下载，如下载速度慢，可以尝试点击备用下载。</li></ul>',
          titleState: "success",
          label: null,
          isPop: false,
          webType: "dreamstime",
          icon: require("@/assets/images/download/ic6_6.png"),
          status: true,
          price: 2,
        },
        {
          title: "Depositphotos",
          subTitle: "",
          tip: '<ul><li style="text-decoration: underline;">请不要使用360浏览器和迅雷下载（经常误判）否则会下载失败，推荐使用系统自带浏览器或者Chrome浏览器直接下载，如下载速度慢，可以尝试点击备用下载。</li></ul>',
          titleState: "success",
          label: null,
          isPop: false,
          webType: "depositphotos",
          icon: require("@/assets/images/download/ic2_2.png"),
          status: true,
          price: 2.5,
        },
        // {
        //   title: "Bigstockphoto",
        //   subTitle: "",
        //   titleState: "success",
        //   label: null,
        //   isPop: false,
        //   webType: "bigstock",
        //   icon: require("@/assets/images/download/ic4_4.png"),
        //   status: true,
        // },
        {
          title: "vectorstock",
          subTitle: "",
          tip: '<ul><li style="text-decoration: underline;">请不要使用360浏览器和迅雷下载（经常误判）否则会下载失败，推荐使用系统自带浏览器或者Chrome浏览器直接下载，如下载速度慢，可以尝试点击备用下载。</li></ul>',
          titleState: "success",
          label: null,
          isPop: false,
          webType: "vectorstock",
          icon: require("@/assets/images/download/ic11_11.png"),
          status: true,
          price: 3.5,
        },
        {
          title: "Alamy",
          subTitle: "",
          tip: '<ul><li>Alamy请复制网站页面上的图片ID下载，如：Image ID: D2I95C</li><li>Alamy仅提供JPG格式，无法提供矢量格式，请按需下载</li><li style="text-decoration: underline;">请不要使用360浏览器和迅雷下载（经常误判）否则会下载失败，推荐使用系统自带浏览器或者Chrome浏览器直接下载，如下载速度慢，可以尝试点击备用下载。</li></ul>',
          titleState: "success",
          label: null,
          webType: "alamy",
          isPop: false,
          icon: require("@/assets/images/download/alamy.png"),
          status: true,
          price: 20,
        },
        {
          title: "Pixelsquid",
          subTitle: "",
          tip: '<ul><li>pixelsquid请复制网站页面上的ID下载，如：https://www.pixelsquid.com/png/retro-car-white-2337168235838838579，则2337168235838838579是素材ID，输入素材ID进行下载</li><li style="text-decoration: underline;">请不要使用360浏览器和迅雷下载（经常误判）否则会下载失败，推荐使用系统自带浏览器或者Chrome浏览器直接下载，如下载速度慢，可以尝试点击备用下载。</li></ul>',
          titleState: "success",
          label: null,
          webType: "pixelsquid",
          isPop: false,
          icon: require("@/assets/images/download/pixelsquid.png"),
          status: true,
          price: 3,
        },
        {
          title: "pngtree",
          subTitle: "",
          tip: '<ul><li>Pngtree请复制图片编号下载，编号为网址栏.html前面的数字</li><li style="text-decoration: underline;">请不要使用360浏览器和迅雷下载（经常误判）否则会下载失败，推荐使用系统自带浏览器或者Chrome浏览器直接下载，如下载速度慢，可以尝试点击备用下载。</li></ul>',
          titleState: "success",
          label: null,
          webType: "pngtree",
          isPop: true,
          icon: require("@/assets/images/download/pngtree.png"),
          status: true,
          price: 2,
        },
        {
          title: "SS音乐",
          subTitle: "",
          titleState: "success",
          isPop: false,
          tip: '<ul><li>如音乐ID提示下架，请联系客服处理，SS音乐均可下载</li><li>音乐仅提供6小时的存储时间，如未及时下载，将会二次扣费，如下载不动或者出现问题，请及时联系上方微信客服处理</li><li style="text-decoration: underline;">请不要使用360浏览器和迅雷下载（经常误判）否则会下载失败，推荐使用系统自带浏览器或者Chrome浏览器直接下载，如下载速度慢，可以尝试点击备用下载。</li></ul>',
          label: null,
          webType: "music",
          icon: "",
          status: true,
          price: 20,
        },
        {
          title: "freepik",
          subTitle: "",
          tip: '<ul><li>Freepik请复制图片编号下载，编号为网址栏.htm前面的数字</li><li style="text-decoration: underline;">请不要使用360浏览器和迅雷下载（经常误判）否则会下载失败，推荐使用系统自带浏览器或者Chrome浏览器直接下载，如下载速度慢，可以尝试点击备用下载。</li></ul>',
          titleState: "success",
          label: null,
          webType: "freepik",
          isPop: false,
          icon: require("@/assets/images/download/ic10_10.png"),
          status: true,
          price: 1.5,
        },
        {
          title: "freepik视频",
          subTitle: "",
          tip: '<ul><li>Freepik视频请复制编号下载，编号为网址栏.htm前面的数字</li><li>视频下载链接速度比较慢，如遇下载不动，卡顿等情况，请及时联系上方客服处理，超时无法处理。</li><li style="text-decoration: underline;">请不要使用360浏览器和迅雷下载（经常误判）否则会下载失败，推荐使用系统自带浏览器或者Chrome浏览器直接下载，如下载速度慢，可以尝试点击备用下载。</li></ul>',
          titleState: "success",
          label: null,
          webType: "vfreepik",
          isPop: true,
          icon: require("@/assets/images/download/ic10_10.png"),
          status: true,
          price: 0,
        },
      ],
      tableDatas: [],
      isMobileFlag: false, // 是否手机端
      showTable: false, //是否显示表格
      tableLoading: false, //加载数据效果
      dialogTableVisible: false, //费用明细弹窗
      accountDialogTableVisible: false, //余额弹窗
      serverDialogVisible: false, //客服弹窗
      form: {
        webType: "",
        imageID: "",
      },
      dataForm: {
        img: "", //缩略图
        id: "", //图片ID
        imgSize: "", //图片大小
        complete: false, //操作状态为按钮
        loading: false, //操作状态为加载
        saleType: "", //默认为空
        price: 0, //图片价格
        priceV4: 0, //图片价格V4
        priceList: [], //视频价格
        videoType: 0, //视频格式
        isfk: false, //是否4k
        isyx: false, //是否严选
        orgPrice: "", //原价
        balance: "", //用户余额
        value: 4, //图片类型默认值
        disabled: true, //是否可选
        videoValue: 0, //视频类型默认值
        videoLabel: "", //视频标签
        videoDisabled: false, //是否可选
        videoOptions: [], //视频类型
        options: [], //图片类型
        webType: this.webType, //网站类型
        downurl: "", //主下载链接
        downurl2: "", //备用下载链接
        type: true, //搜索ID是否正常
        showType: true, //展示类型
        isBuy: false, //是否购买过
        msg: "", //提示消息
        error: false, //下载是否出错
        errorIcon: "", //飞鸟缩略图
        checking: false, //是否查状态
        isChange: false, //默认没有点击切换
      },
      timer: null, //定时器
      isSearching: false, // 是否在搜索
      searchCount: 0, //搜索数量
      isDownloading: false, // 是否正在下载
      isSureDownload: false, // 是否确认下载
      isClearFlag: false, //是否需要清除Url
      isNetError: false, //是否网络通畅标记
    };
  },
  computed: {
    showPost() {
      return this.$store.state.common.showPost;
    },
  },
  mounted() {
    if (this.isMobile()) {
      this.isMobileFlag = true;
    } else {
      this.isMobileFlag = false;
    }
    this.isLoggedIn =
      getToken() != "null" && getToken() != "" && getTempUser() != "temp"
        ? true
        : false;
    //this.$store.commit("updateShowPost", true);
    // if (getNewUser() == 1) {
    //   this.$store.commit("updateShowPost", true);
    // }

    if (
      this.$store.state.common.showAdvert2 == "" ||
      this.$store.state.common.showAdvert2 == null
    ) {
      this.$store.commit("updateShowPost", true);
      this.$store.state.common.showAdvert2 = "1";
    }

    //判断侧边导航栏
    this.$store.commit("headerMenuId", 0);
    this.$store.commit("asideMenuId", 0);
    //data() 是在 store 里的 userInfo 之前求值的，登录后第一次进来可能还是起步价，这里再校准一次
    this.refreshShutterstockPrice();
    this.getStatus();
    let userName = "",
      userEmail = "";
    if (this.$store.state.common.userInfo.mobile) {
      userName = this.$store.state.common.userInfo.mobile;
    }
    if (this.$store.state.common.userInfo.mail) {
      userEmail = this.$store.state.common.userInfo.mail;
    }

    userName = userName ? userName : userEmail; //为空则赋一样的值
    userEmail = userEmail ? userEmail : userName + "@taogetu.com"; //为空需要加邮箱后缀，否则无法修改用户
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    this.timer = null;
    this.$store.commit("updateShowBottum", false);
  },
  methods: {
    /**
     * 用登录用户真实的 shutterstock 单价刷新渠道卡片。
     * 老用户是 1.9，2026-08-22 00:00 之后注册的新用户是 1；拿不到就退回对外起步价。
     */
    refreshShutterstockPrice() {
      const item = this.list.find((it) => it.webType === "shutterstock_V3");
      if (!item) {
        return;
      }
      const { price, isStart } = shutterstockDisplayPrice("shutterstockPriceV3");
      this.$set(item, "price", price);
      this.$set(item, "priceIsStart", isStart);
    },
    //获取tab列表
    getStatus() {
      getShutterStatus()
        .then((res) => {
          let data = JSON.parse(res);
          setV4Status(data.shutterstockV4);
          this.setTabStatus(data.adobestock, "adobestock");
          this.setTabStatus(data.istockphoto, "istockphoto");
          this.setTabStatus(data.dreamstime, "dreamstime");
          this.setTabStatus(data.vistockphoto, "vistockphoto");
          this.setTabStatus(data[`123RF`], "rfoto");
          this.setTabStatus(data.vectorstock, "vectorstock");
          this.setTabStatus(data.Alamy, "alamy");
          this.setTabStatus(data.veer, "veer");
          this.setTabStatus(data.depositphotos, "depositphotos");
        })
        .catch(() => {});
      this.timer = setTimeout(() => {
        getShutterStatus()
          .then((res) => {
            let data = JSON.parse(res);
            setV4Status(data.shutterstockV4);
            this.setTabStatus(data.adobestock, "adobestock");
            this.setTabStatus(data.istockphoto, "istockphoto");
            this.setTabStatus(data.dreamstime, "dreamstime");
            this.setTabStatus(data.vistockphoto, "vistockphoto");
            this.setTabStatus(data[`123RF`], "rfoto");
            this.setTabStatus(data.vectorstock, "vectorstock");
            this.setTabStatus(data.Alamy, "alamy");
            this.setTabStatus(data.veer, "veer");
            this.setTabStatus(data.depositphotos, "depositphotos");
          })
          .catch(() => {});
      }, 60000);
    },
    setTabStatus(data, name) {
      try {
        this.list.forEach((item) => {
          if (item.webType == name) {
            if (data == "online") {
              item.status = true;
            } else {
              item.status = false;
            }
            throw new Error("End Loop");
          }
        });
      } catch (e) {}
    },
    //切换tab
    changeTab(index) {
      this.current = index;
      this.webType = this.list[this.current].webType;
      this.tableDatas = [];
      this.isSearching = false;
      this.isSureDownload = false; // 是否确认下载
      this.showTable = false; //是否显示表格
      this.tableLoading = false; //加载数据效果
      this.dialogTableVisible = false; //费用明细弹窗
      this.accountDialogTableVisible = false; //余额弹窗
      //取消自动下载
      setAutoDownload("0");
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    //打开客服下载提示
    openServerDialog() {
      this.serverDialogVisible = true;
    },
    closeServerDialod() {
      this.serverDialogVisible = false;
    },
    //费用明细
    openConstDetailPop() {
      this.dialogTableVisible = true;
    },
    closeConstDetailPop() {
      this.dialogTableVisible = false;
    },
    //余额明细
    openAccountDetailPop() {
      this.accountDialogTableVisible = true;
    },
    closeAccountDetailPop() {
      this.accountDialogTableVisible = false;
    },
    //获取表格数据
    getTableDatas(result) {
      this.dataForm = {
        img: "", //缩略图
        id: "", //图片ID
        imgSize: "", //图片大小
        complete: false, //操作状态为按钮
        loading: false, //操作状态为加载
        saleType: "", //默认为空
        price: 0, //图片价格
        priceV4: 0, //图片价格
        priceList: [], //视频价格
        videoType: 0, //视频格式
        isfk: false, //是否4k
        isyx: false, //是否严选
        orgPrice: "", //原价
        balance: "", //用户余额
        value: 4, //图片类型默认值
        disabled: false, //是否可选
        videoValue: 0, //视频类型默认值
        videoLabel: "", //视频标签
        videoDisabled: false, //是否可选
        videoOptions: [], //视频类型
        options: [], //图片类型
        webType: this.webType, //网站类型
        isVideo: false, //是否视频
        downurl: "", //主下载链接
        downurl2: "", //备用下载链接
        type: true, //正常
        showType: true, //是否显示类型
        msg: "", //提示消息
        isBuy: false, //是否购买过
        isBuy1: false, //是否购买过1
        isCos: false, //是否腾讯云
        errorIcon: "", //飞鸟 链接
        checking: false, //是否在查状态
        isChange: false, //默认没有点击切换
        isOffset: false, //高级图
        duration: "", //音乐时长-转时间
        title: "", // 音乐title
        videoSize: "", // 音乐作者
        showButton: false, //是否显示按钮
        showButton2: false, //是否显示按钮
      };
      //请求成功后赋值，并且去掉加载效果
      if (result.status == 0) {
        this.dataForm.id = result.recCode;
        this.dataForm.price = result.price;
        this.dataForm.priceV4 = result.priceV4;
        this.dataForm.orgPrice = result.orgPrice;
        this.dataForm.isVideo = false;
        if (
          this.webType != "shutterstock" &&
          this.webType != "shutterstock_V2" &&
          this.webType != "shutterstock_V3"
        ) {
          if (
            this.webType == "adobestock" ||
            this.webType == "depositphotos" ||
            this.webType == "vectorstock"
          ) {
            previewImage({ imageUrl: result.iconUrl })
              .then((result) => {
                this.dataForm.img =
                  "https://download2.sviptuku.com/topze-dispatch/result/" +
                  result.data;
              })
              .catch((error) => {});
          } else {
            this.dataForm.img = result.iconUrl;
          }
        } else {
          if (result.iconUrl != null && result.iconUrl != "") {
            this.dataForm.img =
              "https://img.aatuku.com/preview260/" + result.recCode + ".jpg";
            this.dataForm.errorIcon = result.iconUrl.replace(
              "image.shutterstock.com",
              "img.tukuwu.com"
            );
          }
        }

        if (result.searchDTO.picType == 0) {
          //0为jpg
          this.dataForm.imgSize = result.detailJson[0].px;
          this.dataForm.value = 0;
          this.dataForm.options = [{ value: 0, label: "JPG" }];
        } else if (result.searchDTO.picType == 1) {
          //4为eps
          this.dataForm.value = 1;
          this.dataForm.options = [{ value: 1, label: "ait" }];
        } else if (result.searchDTO.picType == 2) {
          //4为eps
          this.dataForm.value = 2;
          this.dataForm.options = [{ value: 2, label: "indt" }];
        } else if (result.searchDTO.picType == 3) {
          //4为eps
          this.dataForm.value = 3;
          this.dataForm.options = [{ value: 3, label: "psdt" }];
        } else if (result.searchDTO.picType == 4) {
          //4为eps
          this.dataForm.value = 4;
          this.dataForm.options = [{ value: 4, label: "EPS" }];
        } else if (result.searchDTO.picType == 9) {
          this.dataForm.showType = false;
        } else if (result.searchDTO.picType == 10) {
          //10为eps
          this.dataForm.value = 10;
          this.dataForm.options = [{ value: 10, label: "svg" }];
        } else if (result.searchDTO.picType == 11) {
          //11为eps
          this.dataForm.value = 11;
          this.dataForm.options = [{ value: 11, label: "ai" }];
        } else if (result.searchDTO.picType == 12) {
          //11为eps
          this.dataForm.value = 12;
          this.dataForm.options = [{ value: 12, label: "mdl" }];
        } else if (result.searchDTO.picType == 13) {
          this.dataForm.value = 13;
          this.dataForm.options = [{ value: 13, label: "wav" }];
        } else if (result.searchDTO.picType == 14) {
          this.dataForm.value = 14;
          this.dataForm.options = [{ value: 14, label: "PSD" }];
        }

        if (this.webType == "music") {
          this.dataForm.title = result.searchDTO.title;
          this.dataForm.videoSize = result.searchDTO.vedioSize;
          this.dataForm.isVideo = true;
        }

        this.dataForm.isCos = result.detailJson[0].isCos;
        //设置是否购买
        this.dataForm.isBuy = result.detailJson[0].isBuy;
        this.dataForm.isBuy1 = result.detailJson[0].isBuy1;

        if (this.dataForm.isBuy) {
          this.dataForm.msg = "免费";
        }
        this.dataForm.isOffset =
          result.searchDTO.is_loaded == "2" ? true : false;
        //视频搜索
        if (
          this.webType.indexOf("video") != -1 ||
          this.webType.indexOf("vedio") != -1 ||
          this.webType.indexOf("vistockphoto") != -1 ||
          this.webType.indexOf("vadobestock") != -1 ||
          this.webType.indexOf("vfreepik") != -1
        ) {
          this.dataForm.isVideo = true;
          this.dataForm.value = result.searchDTO.picType;
          this.dataForm.priceList = result.priceList;
          if (result.searchDTO.picType == 5) {
            this.dataForm.options = [{ value: 5, label: "MOV" }];
          } else {
            this.dataForm.options = [{ value: 6, label: "MP4" }];
          }
          this.dataForm.isyx = result.detailJson[0].yxflag;
          this.dataForm.isfk = result.detailJson[0].fkflag;
          this.dataForm.videoType = result.videoType;
          switch (this.dataForm.videoType) {
            case 0:
              this.dataForm.videoOptions = [{ value: 0, label: "HD" }];
              this.dataForm.videoLabel = "HD";
              if (this.webType.indexOf("vistockphoto") != -1) {
                this.dataForm.webType = "vistockphoto";
              } else if (this.webType.indexOf("vadobestock") != -1) {
                this.dataForm.webType = "vadobestock";
              } else if (this.webType.indexOf("vfreepik") != -1) {
                this.dataForm.webType = "vfreepik";
              } else {
                this.dataForm.webType = "video";
              }
              this.dataForm.videoValue = 0;
              break;
            case 1:
              this.dataForm.videoOptions = [
                { value: 0, label: "HD" },
                { value: 1, label: "4K" },
              ];
              this.dataForm.videoLabel = "HD";
              if (this.webType.indexOf("vistockphoto") != -1) {
                this.dataForm.webType = "vistockphoto";
              } else if (this.webType.indexOf("vadobestock") != -1) {
                this.dataForm.webType = "vadobestock";
              } else if (this.webType.indexOf("vfreepik") != -1) {
                this.dataForm.webType = "vfreepik";
                this.dataForm.videoOptions = [{ value: 0, label: "4K" }];
                this.dataForm.videoLabel = "4K";
              } else {
                this.dataForm.webType = "video";
              }
              this.dataForm.videoValue = 0;
              break;
            case 2:
              this.dataForm.videoOptions = [{ value: 2, label: "严选HD" }];
              this.dataForm.videoLabel = "严选HD";
              this.dataForm.webType = "videoyx";
              this.dataForm.videoValue = 2;
              this.dataForm.price = result.priceList[2].price;
              break;
            case 3:
              this.dataForm.videoOptions = [
                { value: 2, label: "严选HD" },
                { value: 3, label: "严选4K" },
              ];
              this.dataForm.videoLabel = "严选HD";
              this.dataForm.webType = "videoyx";
              this.dataForm.videoValue = 2;
              this.dataForm.price = result.priceList[2].price;
              break;
          }
        }
      } else {
        this.dataForm.id = result.recCode;
        this.dataForm.msg = result.msg;
        this.dataForm.type = false;
      }
      this.tableDatas.push(this.dataForm);
      this.tableLoading = false;
    },
    //下载ID
    downloadId(flag) {
      this.isSearching = flag;
      this.isDownloading = flag;
    },
    //改变下载状态
    changeDown(flag) {
      this.isSureDownload = flag;
    },
    //搜索ID
    async searchId(prams) {
      if (!this.isLoggedIn) {
        message.error({
          message: "您还没登录用户，请登录",
          showClose: true,
          duration: 4000,
          offset: 100,
        });
        return;
      }
      this.isSearching = true;
      this.isClearFlag = true;
      this.isDownloading = true;
      this.isSureDownload = false;
      this.tableDatas = [];
      this.showTable = true;
      this.tableLoading = true;
      await this.$nextTick();
      this.$EventBus.$emit("move", "1");
      var len = 0;
      const { blance } = await getSessionUser({});
      let mblance = blance;
      //根据余额限制搜索数量
      if (mblance <= 50 && prams.length > 30) {
        //0-50元余额用户限制一次最多搜索30个
        message.error({
          message: "一次性最多只能搜索30个ID",
          showClose: true,
          duration: 4000,
          offset: 100,
        });
        this.downloadId(false);
        this.showTable = false;
        this.tableLoading = false; //加载数据效果
        return;
      } else if (mblance <= 100 && prams.length > 70) {
        //50-100元余额用户限制一次最多搜索70个
        message.error({
          message: "一次性最多只能搜索70个ID",
          showClose: true,
          duration: 4000,
          offset: 100,
        });
        this.downloadId(false);
        this.showTable = false;
        this.tableLoading = false; //加载数据效果
        return;
      } else {
        // 100元以上用户不作限制
      }

      while (len < prams.length && this.isSearching) {
        let dataform = {
          webType: this.webType,
          imageID: prams[len],
        };
        //判断是否22  10位
        if (
          dataform.imageID.startsWith("hi22") &&
          (dataform.webType == "shutterstock" ||
            dataform.webType == "shutterstock_V2" ||
            dataform.webType == "shutterstock_V3")
        ) {
          await this.doSearchHellorf(dataform.imageID);
        } else {
          try {
            let res = await searchImage(dataform);
            if (res.recCode != null && res.recCode != "") {
              this.isNetError = false;
              this.getTableDatas(res);
            } else {
              let res = await searchImage(dataform);
              if (res.recCode != null && res.recCode != "") {
                this.isNetError = false;
                this.getTableDatas(res);
              } else {
                this.isNetError = true;
                message.error({
                  message: "网络异常，请重试",
                  showClose: true,
                  duration: 4000,
                  offset: 100,
                });
              }
            }
          } catch (e) {
            try {
              let res = await searchImage(dataform);
              if (res.recCode != null && res.recCode != "") {
                this.isNetError = false;
                this.getTableDatas(res);
              } else {
                this.isNetError = true;
                message.error({
                  message: "网络异常，请重试",
                  showClose: true,
                  duration: 4000,
                  offset: 100,
                });
              }
            } catch (e) {
              this.isNetError = true;
              message.error({
                message: "网络异常，请重试",
                showClose: true,
                duration: 4000,
                offset: 100,
              });
            }
          }
        }
        this.tableDatas.length > 0
          ? (this.tableLoading = false)
          : (this.tableLoading = true);
        len++;
      }
      if (getAutoDownload() == "1" && this.isSearching) {
        //自动下载--
        this.$EventBus.$emit("auto", "1"); //下一个ID
        this.isDownloading = true;
      } else {
        this.isDownloading = false;
      }
      this.isSearching = false;
      this.isClearFlag = false;
      this.tableLoading = false;
    },
    getTableDatas223(imageID) {
      this.dataForm = {
        img: "", //缩略图
        id: imageID, //图片ID
        imgSize: "", //图片大小
        complete: false, //操作状态为按钮
        loading: false, //操作状态为加载
        saleType: "", //默认为空
        price: 0, //图片价格
        priceList: [], //视频价格
        videoType: 0, //视频格式
        isfk: false, //是否4k
        isyx: false, //是否严选
        orgPrice: "", //原价
        balance: "", //用户余额
        value: 4, //图片类型默认值
        disabled: true, //是否可选
        videoValue: 0, //视频类型默认值
        videoLabel: "", //视频标签
        videoDisabled: false, //是否可选
        videoOptions: [], //视频类型
        options: [], //图片类型
        webType: this.webType, //网站类型
        isVideo: false, //是否视频
        downurl: "", //主下载链接
        downurl2: "", //备用下载链接
        downurl3: "", //海外下载链接
        type: false, //正常
        showType: true, //是否显示格式
        msg: "未搜索到该素材，请联系上方微信客服咨询 ", //提示消息
        isBuy: false, //是否购买过
        isBuy1: false, //是否购买过1
        isChange: false, //是否切换
        isCos: false, //是否腾讯云
        isDownload: false, //是否下载中
        isDownload1: false, //是否备用下载中
        showButton: false, //是否显示按钮
      };

      this.tableDatas.push(this.dataForm);
      this.tableLoading = false;
    },
    noBanlances() {
      //余额不足
      this.tableDatas = [];
      this.isSureDownload = false;
    },
    // hi 开头(hellorf)素材：走 hellorf 搜索校验存在性；命中→正常可下载行，未命中→提示联系客服
    async doSearchHellorf(imageID) {
      let dataform = { webType: "hellorf", imageID: imageID };
      try {
        let res = await searchImage(dataform);
        if (res && res.recCode != null && res.recCode != "") {
          this.isNetError = false;
          this.getTableDatas(res);
        } else {
          this.getTableDatas223(imageID); // 未搜到 → 联系客服
        }
      } catch (e) {
        this.getTableDatas223(imageID);
      }
    },
    async doSearchID(dataform) {
      try {
        let res = await searchImage(dataform);
        if (res.recCode != null && res.recCode != "") {
          this.isNetError = false;
          this.getTableDatas(res);
        } else {
          let res = await searchImage(dataform);
          if (res.recCode != null && res.recCode != "") {
            this.isNetError = false;
            this.getTableDatas(res);
          } else {
            this.isNetError = true;
            message.error({
              message: "网络异常，请重试",
              showClose: true,
              duration: 4000,
              offset: 100,
            });
          }
        }
      } catch (e) {
        let res = await searchImage(dataform);
        if (res.recCode != null && res.recCode != "") {
          this.isNetError = false;
          this.getTableDatas(res);
        } else {
          this.isNetError = true;
          message.error({
            message: "网络异常，请重试",
            showClose: true,
            duration: 4000,
            offset: 100,
          });
        }
      }
    },
  },
};
/*var tawks1,tawks0;
(function(){
  //console.log("test111","embed.tawk.to");
  //tawks1=document.createElement("script"),tawks0=document.getElementsByTagName("script")[0];
  //放到onMounted里面设置，不然没法设置用户名
  // tawks1.async=true;
  // tawks1.src='https://embed.tawk.to/5e883faf69e9320caac026bc/default';
  // tawks1.charset='UTF-8';
  // tawks1.setAttribute('crossorigin','*');
  //tawks0.parentNode.insertBefore(tawks1,tawks0);
})();*/
</script>

<style lang="scss" scoped>
.body-index1 {
  margin-bottom: 80px;
}
::v-deep li {
  list-style: initial !important;
}
::v-deep ul {
  padding: 0 10px;
}
</style>
